import { motion } from "framer-motion";
import { ButtonLink, Img } from "@/components/common";

const DISCIPLINES = ["Brand Identity", "Art Direction", "Campaigns", "Web Design", "E-Commerce", "Mobile Apps", "Web Platforms", "Automation", "AI Systems", "Strategy"];

export const Hero = ({ settings }) => {
  const words = settings.hero_title.split(" ");
  return (
    <section data-testid="hero-section" className="relative flex min-h-[100svh] flex-col overflow-hidden pt-[72px]">
      <div className="absolute inset-y-0 right-0 w-full md:w-[68%]" aria-hidden>
        <Img src={settings.hero_image} alt="" eager sizes="70vw" className="hero-art h-full w-full object-cover opacity-60 md:opacity-90" />
        <div className="absolute inset-0 bg-gradient-to-r from-canvas via-canvas/70 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-canvas to-transparent" />
      </div>
      <div className="grid-lines pointer-events-none absolute inset-0" aria-hidden />

      <div className="container-x relative z-10 flex flex-1 flex-col justify-end pb-10 pt-16 md:pb-14">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1, duration: 0.8 }} className="label-mono flex flex-wrap items-center gap-x-4 gap-y-2" data-testid="hero-name-title">
          <span className="text-fg">{settings.name}</span>
          <span className="h-px w-8 bg-gold/60" aria-hidden />
          <span>{settings.title}</span>
        </motion.p>

        <h1 className="mt-8 font-display font-medium uppercase leading-[0.86] tracking-[-0.02em] text-[clamp(2.9rem,10.5vw,10rem)]" data-testid="hero-title" aria-label={settings.hero_title}>
          {words.map((w, i) => (
            <span key={w} className="block overflow-hidden pb-[0.04em]" aria-hidden>
              <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ delay: 0.2 + i * 0.13, duration: 1, ease: [0.22, 1, 0.36, 1] }}>
                <span className={i === 1 ? "italic" : ""}>{w.replace(".", "")}</span>
                <span className={i === 1 ? "text-gold" : "text-turq"}>.</span>
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.9 }} className="mt-10 grid gap-8 md:grid-cols-12">
          <p className="text-base leading-relaxed text-silver md:col-span-4 md:text-lg" data-testid="hero-subline">{settings.hero_subline}</p>
          <p className="font-display text-2xl italic leading-snug md:col-span-7 md:col-start-6 md:text-[2rem]" data-testid="hero-positioning">{settings.positioning}</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.95, duration: 0.9 }} className="mt-10 flex flex-wrap items-center gap-3" data-testid="hero-ctas">
          {settings.ctas.map((c) => (
            <ButtonLink key={c.label} to={c.href} variant={c.variant} testId={`hero-cta-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {c.label}
            </ButtonLink>
          ))}
        </motion.div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-line/10 pt-5 text-xs text-silver">
          <span className="flex items-center gap-2"><span className="h-2 w-2 animate-pulse rounded-full bg-turq" aria-hidden />{settings.availability}</span>
          <span>{settings.location}</span>
        </div>
      </div>

      <div className="relative z-10 overflow-hidden border-y border-line/10 py-4" aria-hidden>
        <div className="flex w-max animate-marquee gap-10 whitespace-nowrap font-display text-xl italic text-silver">
          {[...DISCIPLINES, ...DISCIPLINES].map((d, i) => (
            <span key={i} className="flex items-center gap-10">{d}<span className="text-gold not-italic">✦</span></span>
          ))}
        </div>
      </div>
    </section>
  );
};
